// extracted by mini-css-extract-plugin
export default {"radio_button":"RadioGroup_radio_button__9Qt0Z","label":"RadioGroup_label__RRaeW","head_label":"RadioGroup_head_label__uXsd-"};